import { LinkList } from 'components/Footer/components/ExternalSiteLinks';

export const JOB_OFFER_KIND_TYPE_AGENT = '0';

export const KODAWARI_TAG_EMPHASIS = '3501';
export const KODAWARI_TAG_EMPLOYMENT_STATUS = '2502';
export const KODAWARI_TAG_OTHER_CONDITIONS = '3502';
export const KODAWARI_ID_NEW = '15';
export const KODAWARI_ID_DEADLINE = '23';

/**
 * 求人詳細のフッター外部サイトリンクリスト
 * 求人掲載・採用企業の方へのリンク先が他画面と異なる
 */
export const JOB_SEARCH_DETAILS_EXTERNAL_SITE_LINK_LIST: LinkList = [
  {
    isExternal: true,
    href: 'https://www.persol-career.co.jp/',
    title: '会社案内',
  },
  {
    isExternal: true,
    href: 'https://www.persol-career.co.jp/corporate/map/',
    title: '拠点地図',
  },
  {
    isExternal: true,
    href: 'https://saiyo-doda.jp/lp/tm/main/?utm_medium=referral&utm_source=doda.jp&utm_campaign=doda.jp_other&cid=referral_dodajp_other_00_00_00',
    title: '求人掲載・採用企業の方へ',
  },
];

/** 詳細条件から探すボタンのリンク先 */
export const SEARCH_BY_DETAIL_CONDITIONS_HREF =
  '/DodaFront/View/JobSearchTop.action?sid=kyujinDetail_JobSearchTop';

// DODASITE-8200 and DODASITE-8201 recomendation variable
export const RECOMMENDABTESTGROUP = {
  ORIGINAL: 'ORIGINAL',
  TEST: 'TEST',
  NA: 'N/A',
};

/** WEB_PC求人詳細ヘッダー登録ボタン追加 定数 */
export const JOB_SEARCH_DETAIL_ADD_HEADER_MEMBER_REGISTRATION_BUTTON_AB_TEST_KEY =
  'ab_16256_atsumeru_detail_pc';
export const JOB_SEARCH_DETAIL_ADD_HEADER_MEMBER_REGISTRATION_BUTTON_AB_TEST_COOKIE_KEY =
  'job_search_detail_registration_button_test_key';
export const JOB_SEARCH_DETAIL_ADD_HEADER_MEMBER_REGISTRATION_BUTTON_AB_TEST_COOKIE_TERM = 30;
export const JOB_SEARCH_DETAIL_ADD_HEADER_MEMBER_REGISTRATION_BUTTON_AB_TEST_GROUP_NO =
  '2';
export const JOB_SEARCH_DETAIL_ADD_HEADER_MEMBER_REGISTRATION_BUTTON_URL =
  '/dcfront/member/memberRegist/?entry_id=26&carry_id=5000000509&carry_class=k';
export const JOB_SEARCH_DETAIL_MEMBER_REGISTRATION_BUTTON_CLICK =
  'PC_detailcv_click';
